module.exports = __webpack_public_path__ + "img/payment_success_pos.79a17e40.png";